<template>
    <div class="letter-details">
        <form>
            <input
                v-if="isDataLoaded"
                type="hidden"
                name="id"
                :value="letterId"
            />
        </form>

        <b-row class="skeleton" v-if="!isDataLoaded">
            <b-col md="5" class="content">
                <div></div>
                <div class="smaller"></div>
                <div class="smaller"></div>
                <div></div>
                <div></div>
            </b-col>
            <b-col md="5" class="content">
                <div></div>
                <div class="smaller"></div>
                <div></div>
                <div></div>
            </b-col>
        </b-row>

        <b-row v-if="isDataLoaded" class="letter">
            <!-- edit -->
            <b-col v-if="mode === 'EDIT'" class="details">
                <letter-edit
                    ref="letterEdit"
                    :letter="letter"
                    @edit-saved="editSaved"
                />
            </b-col>
            <b-col v-if="mode !== 'EDIT'" class="details">
                <!-- view -->
                <b-table-simple borderless>
                    <b-tbody>
                        <b-tr>
                            <b-th>Patient: </b-th>
                            <b-td>
                                <span>
                                    <router-link
                                        v-if="patient"
                                        :to="{
                                            name: 'patient_profile',
                                            params: {
                                                id: patient.encoded_id
                                            }
                                        }"
                                        >{{ patient.name }}
                                    </router-link>
                                </span>
                                <span
                                    v-if="
                                        patient &&
                                        patient.primary_owner.length > 0
                                    "
                                >
                                    (<client-name
                                        showPopover
                                        :title="
                                            getFullName(
                                                patient.primary_owner[0]
                                            )
                                        "
                                        :client="patient.primary_owner[0]"
                                        :text="
                                            getFullName(
                                                patient.primary_owner[0]
                                            )
                                        "
                                    >
                                        <patient-owner-hover
                                            :owner="patient.primary_owner[0]"
                                        />
                                    </client-name>
                                    <span
                                        v-if="patient.active_owners.length > 1"
                                    >
                                        +
                                        <strong
                                            class="text-primary cursor-pointer"
                                            @click="$emit('load')"
                                            >{{
                                                patient.active_owners.length - 1
                                            }}</strong
                                        ></span
                                    >)
                                </span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Title:</b-th>
                            <b-td>
                                {{ letter.title }}
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Date:</b-th>
                            <b-td>
                                {{ _setDateDisplay(Number(letter.date)) }}
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Recipient:</b-th>
                            <b-td>
                                <span v-if="letter.recipient">
                                    <client-name
                                        v-if="letter.recipient_is_client"
                                        :title="letter.recipient.label"
                                        :client="letter.recipient"
                                        :text="letter.recipient.label"
                                    >
                                    </client-name>
                                    <contact-name
                                        v-else-if="letter.recipient_type == 1"
                                        :contact="letter.recipient"
                                        type="business"
                                        :key="letter.recipient.id"
                                    ></contact-name>
                                    <contact-name
                                        v-else
                                        :contact="letter.recipient"
                                        type="actor"
                                        :key="letter.recipient.id"
                                    ></contact-name>
                                </span>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Owner:</b-th>
                            <b-td>
                                <span v-if="client">
                                    <client-name
                                        :title="client.label"
                                        :client="client"
                                        :text="client.label"
                                    >
                                    </client-name>
                                </span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
            <b-col v-if="mode !== 'EDIT'" class="details">
                <b-table-simple borderless>
                    <b-tbody>
                        <b-tr>
                            <b-th>Author:</b-th>
                            <b-td>
                                {{
                                    letter.veterinarian
                                        ? letter.veterinarian.label
                                        : ""
                                }}
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Reference:</b-th>
                            <b-td>
                                <note-link
                                    v-if="letter.soap"
                                    :note="letter.soap"
                                ></note-link>
                            </b-td>
                        </b-tr>
                        <b-tr>
                            <b-th>Attachments:</b-th>
                            <b-td>
                                <span>
                                    <attachment-link
                                        v-for="(attachment,
                                        i) in letter.attachments"
                                        :key="i"
                                        :attachment="attachment"
                                        :separator="
                                            i + 1 < letter.attachments.length
                                                ? ','
                                                : null
                                        "
                                    >
                                    </attachment-link>
                                    <br v-if="letter.attachments.length > 0" />
                                    <button
                                        class="btn btn-secondary"
                                        @click="addAttachmentLetter"
                                    >
                                        <i class="cus-page-add"></i>
                                        Link Attachments
                                    </button>
                                </span>
                            </b-td>
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import PatientOwnerHover from "./../patient/patient-owner-hover.vue";
import LetterEdit from "./letter-edit";

export default {
    components: {
        ClientName: () => import("@/components/commons/client-name"),
        ContactName: () => import("@/components/commons/contact-name"),
        NoteLink: () => import("@/components/commons/medical-note-link"),
        AttachmentLink: () => import("@/components/commons/attachment-link"),
        PatientOwnerHover,
        LetterEdit
    },
    props: {
        mode: {
            type: String
        },
        letter: {
            type: Object
        }
    },
    data() {
        return {};
    },
    watch: {},
    computed: {
        letterId() {
            return this.letter ? this.letter.ID : "";
        },
        patient() {
            return this.letter ? this.letter.patient : "";
        },
        client() {
            return this.letter ? this.letter.client : "";
        },
        isDataLoaded() {
            return this.letter ? true : false;
        }
    },
    beforeDestroy() {},
    methods: {
        getFullName(details) {
            return details.lastname + ", " + details.firstname;
        },
        editSaved(details) {
            this.$emit("edit-saved", details);
        },
        saveEdit() {
            this.$refs.letterEdit.save();
        },
        addAttachmentLetter() {
            this.$parent.promptAddAttachment();
        }
    }
};
</script>
<style type="text/css" lang="scss" scoped>
.letter-details table tbody tr td:first-child {
    font-weight: bold;
}

.letter-details .letter .table th,
.letter-details .letter .table td {
    padding: 0px;
    line-height: 30px;
}
.letter-details .letter .details th {
    width: 110px;
}
</style>
